const userList = {
  tableList: [
    {
      id: 1,
      text: "No",
      name: "sNo",
      visible: true,
      className: "text-center",
    },
    {
      id: 4,
      text: "User",
      name: "username",
      visible: true,
      className: null,
    },
    {
      id: 7,
      text: "Role",
      name: "rolename",
      visible: true,
      className: null,
    },
    {
      id: 8,
      text: "Access Level",
      name: "access_name",
      visible: true,
      className: null,
    },
    {
      id: 2,
      text: "Unit",
      name: "unitname",
      visible: true,
      className: null,
    },
    // {
    //   id: 9,
    //   text: "Department",
    //   name: "departmentname",
    //   visible: true,
    //   className: null,
    // },
    // {
    //   id: 10,
    //   text: "Service Group",
    //   name: "service_group_name",
    //   visible: true,
    //   className: null,
    // },
    {
      id: 5,
      text: "Status",
      name: "status",
      visible: true,
      className: null,
    },
    {
      id: 6,
      text: "Action",
      name: "action",
      visible: true,
      className: null,
    },
  ],
};

const userForm = {
  feilds: [
    {
      id: 0,
      name: "addUser",
      text: "Add New User",
      visible: true,
      element: "label",
      className: [],
      required: false,
    },
    {
      id: 1,
      name: "userName",
      text: "Enter User Name",
      visible: true,
      element: "input",
      required: true,
      input_type: "text",
      placeholder: "Enter user Name",
      icon: "user",
      rules: [
        {
          test: (value) => {
            return value !== null && value.length > 0;
          },
          message: "Please Enter Your User Name",
        },
      ],
      errors: [],
      value: null,
      valid: false,
      state: "",
      disable: false,
      className: [],
    },
    {
      id: 2,
      name: "password",
      text: "Enter User Password",
      visible: true,
      element: "input",
      required: true,
      input_type: "password",
      placeholder: "Enter user Password",
      icon: "lock",
      rules: [
        {
          test: (value) => {
            return value !== null && value.length > 0;
          },
          message: "Please Enter Your password",
        },
      ],
      errors: [],
      value: null,
      valid: false,
      state: "",
      disable: false,
      className: [],
    },
    {
      id: 3,
      name: "role",
      text: "Select Role",
      visible: true,
      element: "select2",
      required: true,
      input_type: "text",
      placeholder: "Select Role",
      icon: "lock",
      rules: [
        {
          test: (value) => {
            return value !== null && value.length > 0;
          },
          message: "Please Select Role",
        },
      ],
      errors: [],
      value: null,
      valid: false,
      state: "",
      disable: false,
      className: [],
    },
    {
      id: 4,
      name: "accessLevel",
      text: "Select Access Level",
      visible: true,
      element: "select2",
      required: true,
      input_type: "text",
      placeholder: "Select Access Level",
      icon: "lock",
      rules: [
        {
          test: (value) => {
            return value !== null && value != "" && value != undefined;
          },
          message: "Please Select Access Level",
        },
      ],
      errors: [],
      value: null,
      valid: false,
      state: "",
      disable: false,
      className: [],
    },
    {
      id: 5,
      name: "unit",
      text: "Select Unit",
      visible: true,
      element: "select2",
      required: true,
      input_type: "text",
      placeholder: "Select Unit",
      icon: "lock",
      rules: [
        {
          test: (value) => {
            return value !== null && value.length > 0;
          },
          message: "Please Select Unit",
        },
      ],
      errors: [],
      value: null,
      valid: false,
      state: "",
      disable: true,
      className: [],
    },
    {
      id: 7,
      name: "department",
      text: "Select Department",
      visible: true,
      element: "select2",
      required: true,
      input_type: "text",
      placeholder: "Select Department",
      icon: "lock",
      rules: [
        {
          test: (value) => {
            return value !== null && value.length > 0;
          },
          message: "Please Select Department",
        },
      ],
      errors: [],
      value: null,
      valid: false,
      state: "",
      disable: true,
      className: [],
    },
    {
      id: 8,
      name: "service",
      text: "Select Service Group",
      visible: true,
      element: "select2",
      required: true,
      input_type: "text",
      placeholder: "Select Service Group",
      icon: "lock",
      rules: [
        {
          test: (value) => {
            return value !== null && value.length > 0;
          },
          message: "Please Service Group",
        },
      ],
      errors: [],
      value: null,
      valid: false,
      state: "",
      disable: true,
      className: [],
    },
    {
      id: 9,
      name: "work_station",
      text: "Select Work Station",
      visible: false,
      element: "select2",
      required: true,
      input_type: "text",
      placeholder: "Select Work Station",
      icon: "lock",
      rules: [
        {
          test: (value) => {
            return value !== null && value.length > 0;
          },
          message: "Please Work Station",
        },
      ],
      errors: [],
      value: null,
      valid: false,
      state: "",
      disable: true,
      className: [],
    },
    {
      id: 20,
      name: "button",
      text: "User",
      visible: true,
      required: false,
      element: "button",
      input_type: "button",
      disable: false,
    },
  ],
};

export { userList, userForm };
